import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import { map, take } from 'ramda'
import moment from 'moment'
import NoRecommendedJobsPlaceholder from '../NoRecommendedJobs'
import {
  StyledContainer,
  StyledTitleWrapper,
  StyledTitle,
  StyledTitleInfo,
  StyledLink,
  StyledJobsWrapper,
  StyledJob,
  StyledJobTitle,
  StyledTopInfoWrapper,
  StyledFacilityInfo,
  StyledBottomInfoWrapper,
  StyledOpenedDate,
  StyledDetailLink,
  StyledLinkIcon,
  StyledButton,
  StyledViewAllJobsLink
} from './styles'
import { makeFilterString, defaultState, createURL } from '../../../utils'

const preferencesLink = 'https://account.pga.org/job-preferences'

export default ({ recommendedJobs }) => {
  if (!recommendedJobs.length) return <NoRecommendedJobsPlaceholder />

  const recommendedIds = map(job => job.jobId, recommendedJobs)
  const nextFilters = makeFilterString({ objectIds: recommendedIds })
  const nextState = {
    ...defaultState,
    configure: {
      ...defaultState.configure,
      filters: nextFilters
    }
  }
  const url = createURL(nextState)
  return (
    <Container>
      <StyledContainer>
        <StyledTitleWrapper>
          <StyledTitle>Recommended for You</StyledTitle>
          <StyledTitleInfo>
            Based on your <StyledLink href={preferencesLink}>Job Preferences</StyledLink>
          </StyledTitleInfo>
        </StyledTitleWrapper>

        <StyledJobsWrapper>
          <Row>
            {take(6, recommendedJobs).map(({ jobTitle, objectID, facilities, created }) => {
              const [facility] = facilities
              const createdDate = moment.unix(created).fromNow()
              return (
                <Col lg='4' md='6' sm='12' key={objectID} style={{ padding: 8 }}>
                  <StyledDetailLink to={`/detail/${objectID}`}>
                    <StyledJob>

                      <StyledTopInfoWrapper>
                        <StyledJobTitle>{jobTitle}</StyledJobTitle>
                        <StyledFacilityInfo>{facility.facility_name}</StyledFacilityInfo>
                        <StyledFacilityInfo>{facility.city}, {facility.state}</StyledFacilityInfo>
                      </StyledTopInfoWrapper>
                      <StyledBottomInfoWrapper>
                        {createdDate && <StyledOpenedDate>{createdDate}</StyledOpenedDate>}
                        <StyledDetailLink to={`/detail/${objectID}`}>
                        Details <StyledLinkIcon />
                        </StyledDetailLink>
                      </StyledBottomInfoWrapper>
                    </StyledJob>
                  </StyledDetailLink>
                </Col>
              )
            })}
          </Row>

          {recommendedJobs.length > 4 && (
            <StyledViewAllJobsLink to={`/search${url}&recommended=true`}>
              <StyledButton outline>View All Recommended Jobs</StyledButton>
            </StyledViewAllJobsLink>
          )}
        </StyledJobsWrapper>
      </StyledContainer>
    </Container>
  )
}
